export default value => {
  if (!value) {
    return ''
  }
  const temp = value.split(' ')
  return temp.slice(0, 20).join(' ') + (temp.length > 20 ? '…' : '')
}
